export default "__VITE_ASSET__PBfk6RUX__"